import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

const OUTLINE = [
  [11.56, 33.17], [12.0, 32.9], [12.6, 32.8], [13.18, 32.9], [13.9, 32.7], [14.6, 32.5], [15.2, 32.35], [15.35, 31.9], [15.7, 31.45],
  [16.2, 31.25], [16.6, 31.2], [17.3, 31.05], [18.1, 30.75], [18.6, 30.45], [19.1, 30.25], [19.6, 30.45], [20.0, 30.85], [20.1, 31.3],
  [19.95, 31.75], [20.07, 32.12], [20.4, 32.45], [21.0, 32.75], [21.7, 32.92], [22.4, 32.85], [22.9, 32.65], [23.2, 32.3], [23.8, 32.1],
  [24.4, 31.95], [25.15, 31.62], [24.85, 31.2], [25.0, 30.0], [24.7, 29.2], [25.0, 28.0], [25.0, 22.0], [25.0, 20.0], [24.0, 20.0],
  [24.0, 19.5], [15.99, 23.45], [15.5, 23.0], [14.2, 22.6], [13.6, 23.0], [11.99, 23.52], [11.5, 24.2], [10.3, 24.5], [10.0, 25.3],
  [9.4, 26.2], [9.85, 26.5], [9.9, 27.4], [9.75, 28.2], [9.85, 29.3], [9.55, 30.2], [10.25, 30.8], [10.2, 31.4], [10.95, 32.4], [11.5, 32.6],
];
const P = ([lon, lat]) => [(lon - 9) * 40, (34 - lat) * 40];
const D = "M" + OUTLINE.map((c) => P(c).map((n) => n.toFixed(1)).join(",")).join("L") + "Z";

const ZONES = { julyana: [20.07, 32.12], sirte: [16.59, 31.2] };
const REFS = [["tripoli", [13.18, 32.9]], ["tobruk", [23.97, 32.08]]];

export const LibyaMap = ({ active, onSelect, className = "" }) => {
  const { t, lang } = useLang();
  const [jx, jy] = P(ZONES.julyana);
  const [sx, sy] = P(ZONES.sirte);
  return (
    <svg viewBox="0 0 660 600" className={className} role="img" aria-label={t.map.title} data-testid="libya-map">
      <defs>
        <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M40 0H0V40" fill="none" stroke="#8EA3BC" strokeOpacity="0.18" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="660" height="600" fill="url(#grid)" />
      <text x={P([16.4, 33.25])[0]} y={P([16.4, 33.25])[1]} textAnchor="middle" className="map-label" fill="#4A5D75" fontStyle="italic">{t.map.sea}</text>
      <motion.path d={D} fill="#1E3A5F" fillOpacity="0.07" stroke="#1E3A5F" strokeWidth="1.6" strokeLinejoin="round"
        initial={{ pathLength: 0 }} whileInView={{ pathLength: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 2.4, ease: "easeInOut" }} />
      <motion.path d={`M${sx},${sy} Q${(sx + jx) / 2},${sy + 70} ${jx},${jy}`} fill="none" stroke="#C59B27" strokeWidth="1.6" strokeDasharray="5 6"
        initial={{ pathLength: 0 }} whileInView={{ pathLength: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 1.6, delay: 1.4 }} />
      <text x={P([18.9, 29.7])[0]} y={P([18.9, 29.7])[1]} textAnchor="middle" className="map-label" fill="#4A5D75">{t.map.oil}</text>
      {REFS.map(([k, c]) => {
        const [x, y] = P(c);
        return (
          <g key={k}>
            <circle cx={x} cy={y} r="3" fill="#8EA3BC" />
            <text x={x} y={y + 18} textAnchor="middle" className="map-label" fill="#4A5D75">{t.map[k]}</text>
          </g>
        );
      })}
      {Object.entries(ZONES).map(([k, c]) => {
        const [x, y] = P(c);
        const on = active === k;
        const labelRight = k === "julyana";
        return (
          <g key={k} onMouseEnter={() => onSelect?.(k)} onFocus={() => onSelect?.(k)} tabIndex={0} role="button" aria-label={t.locationsShort[k].name} className="cursor-pointer outline-none" data-testid={`libya-map-${k}`}>
            <circle cx={x} cy={y} r="18" fill="#C59B27" fillOpacity="0.18" className="map-pulse" />
            <circle cx={x} cy={y} r={on ? 9 : 7} fill={on ? "#C59B27" : "#1E3A5F"} stroke="#fff" strokeWidth="2.5" style={{ transition: "r 300ms, fill 300ms" }} />
            <text x={labelRight ? x + 4 : x - 6} y={y + (labelRight ? -30 : 38)} textAnchor={labelRight ? "middle" : "middle"}
              className={`map-zone ${lang === "ar" ? "font-arabic" : "font-serif"}`} fill="#1E3A5F">{t.locationsShort[k].name}</text>
          </g>
        );
      })}
    </svg>
  );
};
